import axios from "./axiosConfig";

const locationsService = {
  getAllLocations() {
    return axios.get("/inventory/locations");
  },
  
  getLocationById(id) {
    return axios.get(`/inventory/locations/${id}`);
  },
  
  createLocation(data) {
    return axios.post("/inventory/locations", data);
  },
  
  updateLocation(id, data) {
    return axios.put(`/inventory/locations/${id}`, data);
  },
  
  deleteLocation(id) {
    return axios.delete(`/inventory/locations/${id}`);
  },
};

export default locationsService;
